import React from "react";

import Disk from "../disk/Disk";
import { SeriesDataType } from "../type";

const chartId = "total-memory-metrics";

type TotalRamProps = {
  usage?: { usage: number; allocation: number };
  data: SeriesDataType[];
  stackInfo: {
    names: string[];
    bands: Record<string, string>;
  };
};

const TotalRAM = (props: TotalRamProps) => {
  const { data, stackInfo, usage } = props;

  return (
    <Disk
      infoMessage="ram_resource_allocation_info"
      usage={usage}
      chartId={chartId}
      name="RAM"
      data={data}
      stackInfo={stackInfo}
    />
  );
};

export default TotalRAM;
